import stateApi from '@/api/stateApi';
import { Badge } from '@mantine/core';
import { IconBulb, IconCheck, IconCircleCheck, IconHome, IconRocket } from '@tabler/icons-react';
import calculateRecommendations from 'lib/calculateRecommendations';
import calculateTasks from 'lib/calculateTasks';
import { useCallback } from 'react';

export default [
  {
    to: '/inspect',
    icon: <IconHome />,
    label: 'Home',
  },
  {
    to: '/recommendations',
    icon: <IconBulb />,
    label: 'Recommendations',
    rightSection: <RecommendationCount />,
  },
  {
    to: '/jobs',
    icon: <IconRocket />,
    label: 'Jobs',
    rightSection: <JobCount />,
  },
];

function RecommendationCount() {
  const recommendations = stateApi.mergedCollections.useStore(
    useCallback((state) => {
      const rec = calculateRecommendations(state);
      return rec.length;
    }, []),
    { throttle: { seconds: 5 } },
  );

  if (recommendations === 0) {
    return <IconCheck />;
  }

  return (
    <Badge color="white" circle>
      {recommendations}
    </Badge>
  );
}

function JobCount() {
  const count = stateApi.state.useStore(
    useCallback((state) => {
      const tasks = calculateTasks(state);
      return tasks.open.length;
    }, []),
    { throttle: { seconds: 5 } },
  );

  if (count === 0) {
    return <IconCircleCheck />;
  }

  return (
    <Badge color="white" circle>
      {count}
    </Badge>
  );
}
